import PromotionTracking from './TrackingType/PromotionTracking';
import LocalStorageService from '../../Storage/LocalStorageService';
import sendEventTracking from './Events/sendEventTracking';
import TrackingFlowbox, { FlowboxProduct } from '../TrackingFlowbox';

export default class TrackingGoogleAnalytics {
  private API_KEY_FLOWBOX = '69527cdda46a6373a227c2bb7d1677d7';

  private trackingAttributeCreative = 'data-tracking-creative-name';

  private viewProcessed = 'js-viewPromotion--processed';

  private trackingPromotionList: NodeListOf<HTMLElement> =
    document.querySelectorAll(
      `[${this.trackingAttributeCreative}]:not(.${this.viewProcessed})`
    );

  private trackingEvent: HTMLInputElement = document.querySelector(
    `.js-tracking-ecommerce-event:not(.${this.viewProcessed})`
  );

  private trackingCart: HTMLInputElement = document.querySelector(
    `.js-tracking-ecommerce-cart`
  );

  private observer: IntersectionObserver;

  async create(): Promise<IntersectionObserver> {
    const dataLayer: any = window.dataLayer || [];
    const serviceStorage = new LocalStorageService();
    const dataLayerLocalStorage: any =
      serviceStorage.getItem('dataLayer') || [];
    let dataTracking: any = [];

    // Add dataLayer from LocalStorage
    if (dataLayerLocalStorage.length > 0) {
      dataTracking = dataTracking.concat(dataLayerLocalStorage);
      serviceStorage.removeItem('dataLayer');
    }

    // Add tracking in loading page
    if (this.trackingEvent) {
      this.trackingEvent.classList.add(this.viewProcessed);
      dataTracking = dataTracking.concat(JSON.parse(this.trackingEvent.value));
    }

    // Send events tracking
    if (dataTracking.length > 0) {
      const products: FlowboxProduct[] = [];
      let orderId: number;

      dataTracking.forEach((data: any) => {
        sendEventTracking({
          event: data.event,
          ecommerce: data.ecommerce,
          dataLayer,
        });

        if (data.event === 'purchase') {
          orderId = data.ecommerce.transaction_id;

          data.ecommerce.items.forEach((product: any) => {
            products.push({
              id: product.item_id,
              quantity: product.quantity || 1,
              price: product.price || 0,
              currency: data.ecommerce.currency || 'EUR',
            });
          });
        }
      });

      if (products.length > 0) {
        // Initialisation Tracking Flowbox
        const flowboxTracker = new TrackingFlowbox(this.API_KEY_FLOWBOX);

        // Tracking simple
        await flowboxTracker.trackCheckout({
          products,
          orderId,
          enableWebAnalytics: true,
        });
      }
    }

    // Add DATA_TRACKING in window
    if (this.trackingCart) {
      window.DATA_TRACKING = JSON.parse(this.trackingCart.value);
    }

    // Add Promotion tracking
    if (this.trackingPromotionList.length > 0) {
      this.observer = new PromotionTracking().create(
        dataLayer,
        this.trackingAttributeCreative,
        this.viewProcessed,
        this.trackingPromotionList
      );
    }

    return this.observer;
  }
}

declare global {
  interface Window {
    DATA_TRACKING: any;
  }
}
